import { FC, ReactNode, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { buildDisplayText } from '../../../utils';
import Button from '../../Button';

interface DisplayTextKeys {
  TITLE: string;
  SUBTITLE: string;
  BUTTON_TEXT?: string;
}

export interface MessageProductTemplateProp {
  displayTextKeys: DisplayTextKeys;
  translationKey?: string;
  imageSrc?: string;
  title?: ReactNode;
  subTitle?: ReactNode;
  showButton?: boolean;
  onClick?: () => void;
  buttonText?: string;
  content?: () => ReactNode;
  footer?: ReactNode;
}

const MessageTemplate: FC<MessageProductTemplateProp> = ({
  displayTextKeys,
  translationKey,
  imageSrc,
  title,
  subTitle,
  onClick,
  buttonText,
  content,
  footer,
  showButton = true,
}) => {
  const { t } = useTranslation();
  const displayText = useMemo(
    () => buildDisplayText(Object.values(displayTextKeys), translationKey || '', t),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t, displayTextKeys],
  );
  return (
    <div className="h-full w-full rounded-2xl flex-1 flex flex-col items-center bg-white dark:bg-slate-800 p-6 text-center shadow-lg">
      {imageSrc && (
        <img
          className="w-[161.31px] h-[160px] dark:opacity-90"
          src={imageSrc}
          alt={displayText[displayTextKeys.TITLE]}
        />
      )}
      {title || (
        <span className="text-xl font-semibold text-gray-900 dark:text-white mt-4">
          {displayText[displayTextKeys.TITLE]}
        </span>
      )}
      {subTitle || (
        <div className="text-sm mt-2 text-gray-600 dark:text-gray-400">{displayText[displayTextKeys.SUBTITLE]}</div>
      )}
      {content && content()}
      {!content && showButton && displayTextKeys.BUTTON_TEXT && (
        <Button
          className="btn text-sm font-medium bg-orange dark:bg-teal-500 rounded-full mt-8 text-white hover:bg-orange/90 dark:hover:bg-teal-600 transition-colors w-full py-3"
          onClick={onClick}
          props={{
            name: displayTextKeys.BUTTON_TEXT,
          }}
        >
          {buttonText || displayText[displayTextKeys.BUTTON_TEXT]}
        </Button>
      )}
      {footer}
    </div>
  );
};

export default MessageTemplate;
